import React, { useContext, useState, useEffect } from "react";

import {TranslationsContext} from "@proxy/_contexts";

import { LoadingSpinner } from "@proxy/_components";

export default function OverlayBottomThumbnail({
  setOverlayState,
  formData,
  handleRecordingComplete,
  hasThumbnail,
  recordedUrl
}) {
  const translations = useContext(TranslationsContext);

  const [loading, setLoading] = useState(false);

  return (
    <div className={"gc__overlay_bottom_button_contianer"}>
      <button
        type={"button"}
        className={"gc__save_thumbnail_button"}
        onClick={() => {
          setLoading(true);
          handleRecordingComplete(recordedUrl, false);
        }}
        disabled={!hasThumbnail}
      >
        {loading ? <LoadingSpinner /> : <span>{translations.video_recorder_button_save}</span>}
      </button>
    </div>
  );
}
